import FroalaEditor from 'froala-editor';
import { bus } from './main';
import { http } from 'plugins/http';
import { remediatorAPIServerURL,baseServerUrl } from './config'
export default (Vue, Options = {}) => {

  var froalaEditorFunctionality = {

    props: ['tag', 'value', 'config', 'onManualControllerReady','filename'],

    watch: {
      value: function () {
        this.model = this.value;
        this.updateValue();
      }
    },

    render: function (createElement) {
      return createElement(
        this.currentTag,
        [this.$slots.default]
      )
    },

    created: function () {
      this.currentTag = this.tag || this.currentTag;
      this.model = this.value;
      this.serverUrl = baseServerUrl;
      bus.$on('froaladestroy', (data) => {
        if (data) {
          this.destroyEditor();
        }
      });
    },

    // After first time render.
    mounted: function() {
      if (this.SPECIAL_TAGS.indexOf(this.currentTag) != -1) {

        this.hasSpecialTag = true;
      }

      if (this.onManualControllerReady) {
        this.generateManualController();
      } else {
        this.createEditor();
      }
    },

    beforeDestroy: function() {
      this.destroyEditor();
    },

    data: function () {

      return {

        initEvents: [],

        // Tag on which the editor is initialized.
        currentTag: 'div',

        // Editor element.
        _editor: null,
        // config:null,
        // Current config.
        currentConfig: {
          'key' : 'kRB4zA4B1E1F1D1A1qYFa1UQRFQIVc2MSMd1IWPNb1IFd1yD2I2D1B3C7E2A2C5F1A1==',
          'quickInsertTags':[''],
          'toolbarVisibleWithoutSelection': true,
          'attribution': false,
          'imageAddNewLine': true,
          'toolbarButtons': ['bold','italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink',  'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'spellChecker', 'help', 'html', '|', 'undo', 'redo', 'tags_selector','insertImage']
        },

        // Editor options config
        defaultConfig: {
          immediateVueModelUpdate: false,
          vueIgnoreAttrs: null,
        },

        editorInitialized: false,

        SPECIAL_TAGS: ['img', 'button', 'input', 'a'],
        INNER_HTML_ATTR: 'innerHTML',
        hasSpecialTag: false,

        model: null,
        oldModel: null,
        serverUrl:""
      };
    },
    methods: {
      updateValue: function() {
        if (JSON.stringify(this.oldModel) == JSON.stringify(this.model)) {
          return;
        }

        this.setContent();
      },

      createEditor: function() {

        if (this.editorInitialized) {
          return;
        }
        let events = {
          events: {
            'image.beforeUpload':this.imageBeforeUpload.bind(this),
            'image.uploaded': this.imageUploaded.bind(this)
          }
        }
        this.currentConfig = { ...this.currentConfig, ...this.config, ...events } || this.defaultConfig;

        this.setContent(true);

        // Bind editor events.
        this.registerEvents();
        this.initListeners();

        this._editor = new FroalaEditor(this.$el, this.currentConfig)
         
        this.editorInitialized = true;

      },

      setContent: function (firstTime) {

        if (!this.editorInitialized && !firstTime) {
          return;
        }

        if (this.model || this.model == '') {
          
          this.oldModel = this.model;

          if (this.hasSpecialTag) {
            this.setSpecialTagContent();
          } else {
            this.setNormalTagContent(firstTime);
          }
        }
      },

      setNormalTagContent: function(firstTime) {

        var self = this;

        function htmlSet() {

          self._editor.html.set(self.model || '');

          //This will reset the undo stack everytime the model changes externally. Can we fix this?

          self._editor.undo.saveStep();
          self._editor.undo.reset();

        }

        if (firstTime) {
          this.registerEvent('initialized', function () {
            htmlSet();
          });
        } else {
          htmlSet();
        }

      },

      setSpecialTagContent: function() {

        var tags = this.model;

        // add tags on element
        if (tags) {

          for (var attr in tags) {
            if (tags.hasOwnProperty(attr) && attr != this.INNER_HTML_ATTR) {
              this.$el.setAttribute(attr, tags[attr]);
            }
          }

          if (tags.hasOwnProperty(this.INNER_HTML_ATTR)) {
            this.$el.innerHTML = tags[this.INNER_HTML_ATTR];
          }
        }
      },

      destroyEditor: function() {

        if (this._editor) {

          this._editor.destroy();
          this.editorInitialized = false;
          this._editor = null;
        }
      },

      getEditor: function() {
        return this._editor;
      },
      imageBeforeUpload: function(images) {
         // Before image is uploaded
        const data = new FormData();
        data.append('image', images[0]);
        let headers = {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'multipart/form-data'
          }
        };
        let domain = (JSON.parse(localStorage.getItem('selected_domain') || '{}') || {}).domain;
        data.append('domain', domain);
        data.append('type', "froala"+new Date().getTime());
        http.post('common/rules/uploadimages', data, headers).then(res => {
            // this.serverUrl = baseServerUrl;
            res.data.status && this._editor.image.insert(`${this.serverUrl}/static/images/${res.data.link}`, null, null, this._editor.image.get());
          }).catch(err => {
            console.log(err);
          });
        return false;
      },
      // imageBeforeUpload: function(files) {// as base64
      //   var editor = this._editor;
      //    if (files.length) {
      //      // Create a File Reader.
      //      var reader = new FileReader();
      //      // Set the reader to insert images when they are loaded.
      //      reader.onload = function(e) {
      //        var result = e.target.result;
      //        editor.image.insert(result, null, null, editor.image.get());
      //      };
      //      // Read image as base64.
      //      reader.readAsDataURL(files[0]);
      //    }
      //    editor.popups.hideAll();
      //    // Stop default upload chain.
      //    return false;
      // },
      imageUploaded: function (response) {
       
        // Image was uploaded to the server.
      },
     
      generateManualController: function() {
        var controls = {
          initialize: this.createEditor,
          destroy: this.destroyEditor,
          getEditor: this.getEditor
        };

        this.onManualControllerReady(controls);
      },

      updateModel: function () {

        var modelContent = '';

        if (this.hasSpecialTag) {

          var attributeNodes = this.$el[0].attributes;
          var attrs = {};

          for (var i = 0; i < attributeNodes.length; i++ ) {

            var attrName = attributeNodes[i].name;
            if (this.currentConfig.vueIgnoreAttrs && this.currentConfig.vueIgnoreAttrs.indexOf(attrName) != -1) {
              continue;
            }
            attrs[attrName] = attributeNodes[i].value;
          }

          if (this.$el[0].innerHTML) {
            attrs[this.INNER_HTML_ATTR] = this.$el[0].innerHTML;
          }

          modelContent = attrs;
        } else {

          var returnedHtml = this._editor.html.get();
          if (typeof returnedHtml === 'string') {
            modelContent = returnedHtml;
          }
        }

        this.oldModel = modelContent;
        this.$emit('input', modelContent);
      },

      initListeners: function() {
        var self = this;
        this.registerEvent('initialized', function () {
          if (self._editor.events) {
            // bind contentChange and keyup event to froalaModel
            self._editor.events.on('contentChanged', function () {
              self.updateModel();
            });

            if (self.currentConfig.immediateVueModelUpdate) {
              self._editor.events.on('keyup', function () {
                self.updateModel();
              });
            }
          }
        })
      },

      // register event on editor element
      registerEvent: function (eventName, callback) {
        
        if (!eventName || !callback) {
          return;
        }
        // Initialized event.
        if (eventName == 'initialized') {

          this.initEvents.push(callback);
        }
        else {
          if (!this.currentConfig.events) {
            this.currentConfig.events = {};
          }

          this.currentConfig.events[eventName] = callback;
        }

      },

      registerEvents: function () {
        // Handle initialized on its own.
        this.registerInitialized();

        // Get current events.
        var events = this.currentConfig.events;

        if (!events) {
          return;
        }

        for (var event in events) {
          if (events.hasOwnProperty(event) && event != 'initialized') {
            this.registerEvent(event, events[event]);
          }
        }
      },

      registerInitialized: function () {
        // Bind initialized.
        if(!this.currentConfig.events) {
          this.currentConfig.events = {};
        }

        // Set original initialized event.
        if (this.currentConfig.events.initialized) {
          this.registerEvent('initialized', this.currentConfig.events.initialized);
        }

        // Bind initialized event.
        this.currentConfig.events.initialized = () => {
          for (var i = 0; i < this.initEvents.length; i++) {
            this.initEvents[i].call(this._editor);
          }
        }
      }
    }
  };

  Vue.component('Froala', froalaEditorFunctionality);

  var froalaViewFunctionality = {

    props: ['tag', 'value'],

    watch: {
      value: function (newValue) {
        this._element.innerHTML = newValue;
      }
    },

    created: function () {
      this.currentTag = this.tag || this.currentTag;
    },

    render: function (createElement) {
      return createElement(
        this.currentTag,
        {
          class: 'fr-view'
        }
      )
    },

    // After first time render.
    mounted: function() {
      this._element = this.$el;

      if (this.value) {
         this._element.innerHTML = this.value
      }
    },

    data: function () {

      return {
        currentTag: 'div',
        _element: null,
      };
    }
  };

  Vue.component('FroalaView', froalaViewFunctionality);
}



// WEBPACK FOOTER //
// ./src/vue-froala.js